import Backbone from "backbone";
import $ from "jquery";
import * as _ from "underscore";

import * as editCardDialog from "editCardDialog";
import { formattedContextHtml } from "models/UserWordModel";
import * as mustcache from "mustcache";
import * as dateUtils from "shared/dateUtils";
import * as utils from "shared/utils";
import * as splitTest from "splitTest";

// only allow one pop up at a time
let currentPopUp;

/** @type {any} */
const WordPopUpView = Backbone.View.extend({
  tagName: "div",
  className: "yourWordPopUpContainer",
  events: {
    "click .closeDialogButton, .dismissArea": "remove",
    "click .editWord": "editWord",
    "click .deleteWord": "deleteWord",
    "click .recallWord": "recallWord",
    "click .addContext": "addContext",
  },
  editWord: function (event) {
    const userWord = this.remoteUserWords.get(
      $(event.target).closest("[data-id]").attr("data-id")
    );

    editCardDialog.show(userWord, {
      title: "Edit Word / Phrase",
    });
  },
  addContext: function (event) {
    const userWord = this.remoteUserWords.get(
      $(event.target).closest("[data-id]").attr("data-id")
    );
    const contexts = _.clone(userWord.get("contexts"));

    // un-populate bookID
    _.each(contexts, (context) => {
      if (context.bookID && context.bookID._id) {
        context.bookID = context.bookID._id;
      }
    });

    contexts.push(this.options.newContext);
    userWord.save({ contexts: contexts }, { patch: true });
  },
  deleteWord: function (event) {
    const userWord = this.remoteUserWords.get(
      $(event.target).closest("[data-id]").attr("data-id")
    );

    userWord.destroy();

    if (this.remoteUserWords.length === 0) {
      this.remove();
    }
  },
  recallWord: function (event) {
    const userWord = this.remoteUserWords.get(
      $(event.target).closest("[data-id]").attr("data-id")
    );

    userWord.recall({
      recallEase: 4,
      strength: 0.5, // because it's just a passive recall
    });

    this.remove();
  },
  initialize: function (options) {
    if (currentPopUp) {
      currentPopUp.remove();
    }
    currentPopUp = this;

    this.options = options;

    // phrase: a UserWord
    // element: the word to attach to
    //
    // create our own RemoteUserWords not to mess up the reader sidebar one
    this.remoteUserWords = options.remoteUserWordsFactory();
    this.fetching = true;

    this.remoteUserWords.fetch({
      data: {
        exactPhrasesSearch: options.phrases.join("|"),
      },
      success: () => {
        this.fetching = false;

        this.listenTo(
          this.remoteUserWords,
          "change add remove",
          this.render.bind(this)
        );
        this.render();

        if (options.fetchedWordCallback) {
          options.fetchedWordCallback(this.remoteUserWords.first());
        }
      },
    });

    options.containerElement.append(this.$el);

    this.listenTo(
      options.readerViewModel,
      "pageLayoutUpdated",
      this.updatePosition.bind(this)
    );
    this.updatePosition();
    this.render();

    splitTest.trackEvent("openWordPopUp");
  },
  updatePosition: function () {
    const targetOffset = this.options.targetElement.offset();
    const containerOffset = this.options.containerElement.offset();

    const verticalPadding = 8;
    const horizontalMargin = 20;

    this.$el.css({
      top: targetOffset.top - containerOffset.top - verticalPadding,
      //left: targetOffset.left - containerOffset.left,
      //width: this.options.targetElement.width(),
      left: horizontalMargin,
      right: horizontalMargin,
      height: this.options.targetElement.height() + verticalPadding * 2,
    });

    if (!this.popUp) {
      // not yet rendered
      return;
    }

    this.$el.find(".dismissArea").css({
      left: targetOffset.left - containerOffset.left - horizontalMargin,
      width: this.options.targetElement.width(),
    });

    const above = "yourWordPopUp-above";
    const below = "yourWordPopUp-below";
    this.popUp.removeClass(above + " " + below);

    const halfY =
      targetOffset.top -
      containerOffset.top +
      this.options.targetElement.height() / 2;

    let maxHeight;
    if (halfY > this.options.containerElement.height() / 2) {
      this.popUp.addClass(above);
      maxHeight = halfY - 50;
    } else {
      this.popUp.addClass(below);
      maxHeight = this.options.containerElement.height() - halfY - 40;
    }
    this.popUp.css("max-height", maxHeight);
  },
  render: function () {
    const userWords = this.remoteUserWords.toJSON();
    const templateData = {
      userWords,
      fetching: this.fetching,
      noWords: userWords.length === 0,
    };

    _.each(templateData.userWords, (userWord) => {
      let newContext = this.options.newContext;
      _.each(userWord.contexts, (context) => {
        if (newContext && newContext.text === context.text) {
          newContext = undefined;
        }
        context.formattedHtml = formattedContextHtml(
          context.text,
          userWord.word
        );
      });
      userWord.type = utils.notWordRegExp().test(userWord.word)
        ? "phrase"
        : "word";

      userWord.allTranslationsString = [
        userWord.translation,
        ...userWord.alternativeTranslations,
      ].join(" / ");

      if (newContext) {
        userWord.newContextHtml = formattedContextHtml(
          newContext.text,
          userWord.word
        );
      }

      if (
        !userWord.recalledThisSession &&
        (!userWord.nextDate ||
          dateUtils.parse(userWord.nextDate) < new Date().getTime())
      ) {
        userWord.recallButton = true;
      }
    });

    mustcache.render("wordPopUp", templateData, (html) => {
      this.$el.html(html);
      this.popUp = this.$el.find(".yourWordPopUp");
      this.updatePosition();
      this.delegateEvents();
    });
  },

  remove: function () {
    Backbone.View.prototype.remove.call(this);
  },
});

export default WordPopUpView;
